import { Dialog, OpenDialog } from './dialog';
import Loading from './loading/index';
import styles from './loading/index.less';
import React, { useEffect, useMemo, useRef, useState } from 'react';

const loadingClass = styles.loadingFrame;
const loadingOvertClass = styles.loadingFrameOvert;
const loadingTargetClass = styles.loadingTarget;

export class LoadingService {
  delayOpen = 0;
  delayClose = 200;
  count = 0;
  openTimer: any | null = null;
  closeTimer: any | null = null;
  loadingInstance: Dialog | null = null;
  loadingComponent = Loading;

  constructor() {
  }

  open() {
    document.body.classList.add(loadingOvertClass);
    if (document.body.querySelectorAll('.' + loadingTargetClass).length) {
      return;
    }
    if (!this.loadingInstance) {
      this.loadingInstance = OpenDialog(this.loadingComponent);
      this.loadingInstance.afterClosed().finally(() => {
        this.loadingInstance = null;
      });
    }
  }

  close() {
    document.body.classList.remove(loadingOvertClass);
    if (this.loadingInstance) {
      this.loadingInstance.close();
    }
  }

  increase() {
    this.count++;
    this.refresh();
  }

  decrease() {
    this.count = Math.max(this.count - 1, 0);
    this.refresh();
  }

  refresh() {
    if (this.count > 0) {
      document.body.classList.add(loadingClass);
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      if (!this.openTimer) {
        this.openTimer = setTimeout(() => {
          this.openTimer = null;
          this.open();
        }, this.delayOpen);
      }
    } else {
      document.body.classList.remove(loadingClass);
      if (this.openTimer) {
        clearTimeout(this.openTimer);
        this.openTimer = null;
      }
      if (!this.closeTimer) {
        this.closeTimer = setTimeout(() => {
          this.closeTimer = null;
          this.close();
        }, this.delayClose);
      }
    }
  }
}

let singleton;

export function increaseLoading() {
  if (!singleton) {
    singleton = new LoadingService();
  }
  singleton.increase();
}

export function decreaseLoading() {
  if (!singleton) {
    singleton = new LoadingService();
  }
  singleton.decrease();
}

export function getLoadingInstance() {
  if (!singleton) {
    singleton = new LoadingService();
  }
  return singleton;
}
